module.exports = __webpack_public_path__ + "img/i_arena_TITLE_off.d063733.png";